import { APP_BASE_HREF, PathLocationStrategy, PlatformLocation } from '@angular/common';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class PreviewPreserveQueryLocationStrategy extends PathLocationStrategy {
  private readonly initialQueryParam: string;

  constructor() {
    const _platformLocation = inject(PlatformLocation);
    const _baseHref = inject(APP_BASE_HREF, { optional: true });

    super(_platformLocation, _baseHref);
    const search = typeof window !== 'undefined' ? window.location.search : '';
    if (search !== '?preview=true') return;

    this.initialQueryParam = search;
  }

  override prepareExternalUrl(internal: string): string {
    if (!this.initialQueryParam) return super.prepareExternalUrl(internal);

    const url = super.prepareExternalUrl(internal);
    if (url.includes(this.initialQueryParam)) return url;

    return url + this.initialQueryParam;
  }
}
